export const FETCH_MAINTENANCES_REQUEST = "FETCH_MAINTENANCES_REQUEST";
export const FETCH_MAINTENANCES_SUCCESS = "FETCH_MAINTENANCES_SUCCESS";
export const FETCH_MAINTENANCES_FAIL = "FETCH_MAINTENANCES_FAIL";
export const UPDATE_MAINTENANCE_REQUEST = "UPDATE_MAINTENANCE_REQUEST";
export const UPDATE_MAINTENANCE_SUCCESS = "UPDATE_MAINTENANCE_SUCCESS";
export const UPDATE_MAINTENANCE_FAIL = "UPDATE_MAINTENANCE_FAIL";
export const FETCH_MAINTENANCE_REQUEST = "FETCH_MAINTENANCE_REQUEST";
export const FETCH_MAINTENANCE_SUCCESS = "FETCH_MAINTENANCE_SUCCESS";
export const FETCH_MAINTENANCE_FAIL = "FETCH_MAINTENANCE_FAIL";
export const CREATE_MAINTENANCE_REQUEST = "CREATE_MAINTENANCE_REQUEST";
export const CREATE_MAINTENANCE_SUCCESS = "CREATE_MAINTENANCE_SUCCESS";
export const CREATE_MAINTENANCE_FAIL = "CREATE_MAINTENANCE_FAIL";
export const DELETE_MAINTENANCE_REQUEST = "DELETE_MAINTENANCE_REQUEST";
export const DELETE_MAINTENANCE_SUCCESS = "DELETE_MAINTENANCE_SUCCESS";
export const DELETE_MAINTENANCE_FAIL = "DELETE_MAINTENANCE_FAIL";
